import {
  enviarDadosMetaTrack,
  StatusMetaTrack,
} from '@/services/metaTrackService';
import { MetaTrack } from '@/services/pagamentos/types/pagamento';

function converterParaPascalCase(chave: string): string {
  return chave
    .split('_')
    .map((parte) =>
      parte.length > 0
        ? parte.charAt(0).toUpperCase() + parte.slice(1).toLowerCase()
        : '',
    )
    .join('');
}

export function useMetaTrackHook() {
  function recuperarMetaTrackSessionStorage() {
    try {
      let metaTrackParametersParsed: MetaTrack | undefined = undefined;
      const metaTrackParameter = sessionStorage.getItem('chippu@metaTrack');
      if (metaTrackParameter) {
        metaTrackParametersParsed = JSON.parse(metaTrackParameter) as MetaTrack;
      }

      if (!metaTrackParametersParsed) return undefined;

      return metaTrackParametersParsed;
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }

  async function recuperarQueryStringDaUrl(event_name = 'view_page') {
    try {
      if (typeof window === 'undefined') return;

      const urlParams = new URLSearchParams(window.location.search);
      const metaTrackValues: Record<string, string> = {};

      urlParams.forEach((value, key) => {
        if (
          key.startsWith('utm_') ||
          key.startsWith('fb') ||
          key === 'fbclid' ||
          key === 'fbc' ||
          key === 'fbp'
        ) {
          const novaChave = converterParaPascalCase(key);
          metaTrackValues[novaChave] = value;
        }
      });

      if (Object.keys(metaTrackValues).length > 0) {
        try {
          enviarDadosMetaTrack({
            tracking: metaTrackValues,
            status: event_name as StatusMetaTrack,
          });
        } catch (error) {
          console.warn('Não foi possível registrar os eventos', error);
        }

        sessionStorage.setItem(
          'chippu@metaTrack',
          JSON.stringify(metaTrackValues),
        );
      }
    } catch (error) {
      console.error(error);
    }
  }

  function enviarEventosMetaTrack(event: StatusMetaTrack) {
    try {
      let metaTrackParametersParsed: MetaTrack | undefined = undefined;
      const metaTrackParameter = sessionStorage.getItem('chippu@metaTrack');
      if (metaTrackParameter) {
        metaTrackParametersParsed = JSON.parse(metaTrackParameter) as MetaTrack;
      }

      if (!metaTrackParametersParsed)
        throw new Error('Não foi possível recuperar os valores do metaTrack');

      enviarDadosMetaTrack({
        tracking: metaTrackParametersParsed,
        status: event,
      });
    } catch (error) {
      console.warn('Não foi possível registrar os eventos', error);
    }
  }

  return {
    recuperarQueryStringDaUrl,
    enviarEventosMetaTrack,
    recuperarMetaTrackSessionStorage,
  };
}
